// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ac36ca94","453":"0693dd4c","667":"785b43d6"}[chunkId] + ".chunk.js";
};